setTimeout(() => {
    const elms = document.querySelector("#cart-notification");
  if(elms){
    const observer = new MutationObserver(() => {
        console.log(123);
      BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false);
    })
    observer.observe(elms, {attributes: true})
  }
}, 300)

if(window.location.pathname === '/pages/trade-application'){
  let interval =setInterval(() => {
    const elms = document.querySelectorAll("#bss-b2b-register-form .bss-b2b-rf-field:not(.field-file)");
      if(elms.length){
        clearInterval(interval);
        elms.forEach(item => {
        let input = item.querySelector("input, textarea");
          if(item.classList.contains('field-phone')){
            input = item.querySelectorAll("input")[1];
          }
        const label = item.querySelector("label");
        if(input && label){
        input.after(label);
        input.placeholder = label.textContent;
        }
      })
    }
  }, 500)
    setTimeout(() => {
      clearInterval(interval);
    }, 5000)
}